var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("TipDialog", {
        attrs: {
          data: _vm.list,
          visible: _vm.versionVisible,
          "is-disable": _vm.quotationList.customConfig,
        },
        on: { close: _vm.cancel, confirm: _vm.handelVersionChange },
      }),
      _c("RecalculateDialog", {
        attrs: {
          visible: _vm.recalculateVisible,
          "quotation-list": _vm.quotationList,
        },
        on: {
          close: _vm.recalculateCancel,
          confirm: _vm.handelRecalculateChange,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }